<template>
  <div>
    <i :class="`badge badge-warning help`">
      <img
        v-if="img"
        :src="require(`@/assets/icons/${img}.png`)"
        alt="ireal badge"
      />
    </i>
  </div>
</template>

<script>
export default {
  name: "badge-widget",
  props: ["img", "colorBadge"]
};
</script>
<style scoped></style>
